import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ExcelService,
  PurchaseReportService,
} from "../../../services/index";
declare var google;

@Component({
  selector: "bit-stock-report",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./bitStockReport.html",
})
export class bitStockReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  typeList = ["BABLA", "SHIRT", "BOTH"];
  //   sleeveList = ['H/S','F/S', 'BOTH'];
  //   sizeList = ['12-16','36-44', 'BOTH'];
  widthList = ["36", "44", "58", "ALL"];
  fabStyleList = ["CHECKS", "PLAIN", "PANEL", "PRINT", "ALL"];
  reportList = ["REF NO", "WIDTH WISE", "STYLE WISE", "DESIGN WISE"];

  seasonList = [];
  gridOptions: any;
  dataList = [];
  qualityList: any;
  colorList: any;
  codeList: any;
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearList = [];

  filter = {
    groupby: "ref_no",
    fin_id: "",
    design_no: "",
    from_date: "",
    to_date: "",
    bit_ref_no: "",
    fab_style: "",
    width: "",
    type: "",
    report_type: "REF NO",
    mtr_from: "",
    mtr_to: "",
    // size : '',
    // sleeve : ''
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "po_no",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "Cutting Report",
    columns: [],
    rows: [],
  };

  partyList = [];
  exceldata: any;

  @ViewChild("qualityAuto") qualityAuto;
  @ViewChild("typeAuto") typeAuto;
  @ViewChild("typeListAuto") typeListAuto;
  @ViewChild("sleeveAuto") sleeveAuto;
  @ViewChild("sizeAuto") sizeAuto;
  @ViewChild("reportType") reportType;

  @ViewChild("filterPanel") filterPanel;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  columns = [];
  partycodeList = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  swatchList = ["YES", "NO"];
  sampList = ["YES", "NO"];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private purReport: PurchaseReportService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    public toasterService: ToasterService
  ) {
    this.filter.type = "BOTH";
    //   this.filter.sleeve = 'BOTH';
    //   this.filter.size = 'BOTH';
    this.filter.fab_style = "ALL";
    this.filter.width = "ALL";
  }

  ngOnInit(): void {
    this.getColumns();
    this.finyearCombo();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  onCellClick(event) {
    let row = event.row;
    if (this.filter.report_type == "REF NO") {
      if (this.filter.groupby == "ref_no") {
        this.filter.groupby = "design_no";
        this.filter.bit_ref_no = row.bit_ref_no;
      }
    } else if (this.filter.report_type == "WIDTH WISE") {
      if (this.filter.groupby == "ref_no") {
        this.filter.groupby = "design_no";
        this.filter.width = row.width;
      }
    } else if (this.filter.report_type == "STYLE WISE") {
      if (this.filter.groupby == "ref_no") {
        this.filter.groupby = "design_no";
        this.filter.fab_style = row.fab_style;
      }
    }

    this.getOrderList();
  }

  onbackbutton() {
    if (this.filter.report_type == "REF NO") {
      if (this.filter.groupby == "design_no") {
        this.filter.groupby = "ref_no";
        this.filter.bit_ref_no = "";
      }
    } else if (this.filter.report_type == "WIDTH WISE") {
      if (this.filter.groupby == "design_no") {
        this.filter.groupby = "ref_no";
        this.filter.width = "ALL";
      }
    } else if (this.filter.report_type == "STYLE WISE") {
      if (this.filter.groupby == "design_no") {
        this.filter.groupby = "ref_no";
        this.filter.fab_style = "ALL";
      }
    }

    this.getOrderList();
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getOrderList();
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      this.getOrderList();
    });
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  getOrderList(): void {
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );

    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.purReport
      .getBitListReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;

        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };
        that.printConfig = {
          title: "Cutting Report",
          columns: res.columns,
          rows: that.orderList,
        };
        that.exceldata = that.getData(res.columns, res.data);
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/bitStockReport/bitStockReport.ts